const getDefaultState = () => {
  return {
    // anno: 0,
    data_ultimo_invio_raas_formazione: null, // "2023-01-02T13:35:10.715Z",
    denominazione_raas_formazione: null, //"string",
    codice_fiscale_raas_formazione: null, //"string",
    codice_affiliazione_raas_formazione: null, //"string",
    id_comitato_raas_formazione: null, //0,
    stati_invio_raas_formazione: null, //"string",
    rowtoskip_raas_formazione: 0, //0,
    fetchrows_raas_formazione: 25, //0,
    sortcolumn_raas_formazione: "data_inizio", //"string",
    sortorder_raas_formazione: "desc", //"string",
    currentPage_raas_formazione: 1,
  };
};
const state = getDefaultState();

const getters = {
  //   anno: (state) => state.disciplinaRanking,
  data_ultimo_invio_raas_formazione: (state) =>
    state.data_ultimo_invio_raas_formazione,
  denominazione_raas_formazione: (state) => state.denominazione_raas_formazione,
  codice_fiscale_raas_formazione: (state) =>
    state.codice_fiscale_raas_formazione,
  codice_affiliazione_raas_formazione: (state) =>
    state.codice_affiliazione_raas_formazione,
  id_comitato_raas_formazione: (state) => state.id_comitato_raas_formazione,
  stati_invio_raas_formazione: (state) => state.stati_invio_raas_formazione,
  rowtoskip_raas_formazione: (state) => state.rowtoskip_raas_formazione,
  fetchrows_raas_formazione: (state) => state.fetchrows_raas_formazione,
  sortcolumn_raas_formazione: (state) => state.sortcolumn_raas_formazione,
  sortorder_raas_formazione: (state) => state.sortorder_raas_formazione,
  currentPage_raas_formazione: (state) => state.currentPage_raas_formazione,
};

const actions = {
  setInviateFormazioneRaas: (context) => {
    context.commit("setStati_invio_raas_formazione", "2");
  },
  setDaInviareFormazioneRaas: (context) => {
    context.commit("setStati_invio_raas_formazione", "1");
  },
  setErroriFormazioneRaas: (context) => {
    context.commit("setStati_invio_raas_formazione", "3");
  },
  setDaReinviareFormazioneRaas: (context) => {
    context.commit("setStati_invio_raas_formazione", "4");
  },
};
const mutations = {
  setData_ultimo_invio_raas_formazione: (state, value) => {
    state.data_ultimo_invio_raas_formazione = value;
  },
  setDenominazione_raas_formazione: (state, value) => {
    state.denominazione_raas_formazione = value;
  },
  setCodice_fiscale_raas_formazione: (state, value) => {
    state.codice_fiscale_raas_formazione = value;
  },
  setCodice_affiliazione_raas_formazione: (state, value) => {
    state.codice_affiliazione_raas_formazione = value;
  },
  setId_comitato_raas_formazione: (state, value) => {
    state.id_comitato_raas_formazione = value;
  },
  setStati_invio_raas_formazione: (state, value) => {
    if (
      state.stati_invio_raas_formazione &&
      state.stati_invio_raas_formazione.includes(value)
    ) {
      if (state.stati_invio_raas_formazione.includes(`,${value}`))
        state.stati_invio_raas_formazione =
          state.stati_invio_raas_formazione.replace(`,${value}`, "");
      else if (state.stati_invio_raas_formazione.includes(`${value},`))
        state.stati_invio_raas_formazione =
          state.stati_invio_raas_formazione.replace(`${value},`, "");
      else
        state.stati_invio_raas_formazione =
          state.stati_invio_raas_formazione.replace(`${value}`, "");
    } else {
      state.stati_invio_raas_formazione = `${
        state.stati_invio_raas_formazione
          ? state.stati_invio_raas_formazione + ","
          : ""
      }${value}`;
    }
    if (state.stati_invio_raas_formazione === "")
      state.stati_invio_raas_formazione = null;
  },
  //   setInviateFormazioneRaas: (state, value) => {
  //     state.stati_invio_raas_formazione =  `${state.stati_invio_raas_formazione},${value}`;
  //   },

  setFetchRowsFormazioneRaas: (state, value) => {
    state.currentPage_raas_formazione = 1;
    state.rowtoskip_raas_formazione = 0;
    state.fetchrows_raas_formazione = value;
  },
  setCurrentPageFormazioneRaas: (state, value) => {
    state.currentPage_raas_formazione = value;
    state.rowtoskip_raas_formazione = parseInt(
      (state.currentPage_raas_formazione - 1) * state.fetchrows_raas_formazione
    );
  },
  setSortColumnFormazioneRaas: (state, value) => {
    state.sortcolumn_raas_formazione = value;
  },
  setSortOrderFormazioneRaas: (state, value) => {
    state.sortorder_raas_formazione = value;
  },
  resetFiltersFormazioneRaas: (state) => {
    Object.assign(state, getDefaultState());
  },
  setRowsToSkipFormazioneRaas: (state) => {
    state.currentPage_raas_formazione = 1;
    state.rowtoskip_raas_formazione = 0;
  },
  //   setTutteLeStagioniRanking: (state) => {
  //     state.tutteStagioniRanking = !state.tutteStagioniRanking;
  //     state.currentPageRanking = 1;
  //     state.rowsToSkipRanking = 0;
  //   },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
